export default function Logo({ size = 34, withWordmark = false, tone = "dark" }) {
  const wordmarkColor = tone === "dark" ? "#eef1f6" : "#0e1420";
  const subColor = tone === "dark" ? "#9aa4b2" : "#5c6877";
  return (
    <div className="flex items-center gap-2.5" data-testid="cc-logo">
      <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-label="CurrentControl">
        <circle cx="16" cy="13" r="9.5" fill="#ffc72c" stroke="#fff" strokeWidth="0.6" strokeOpacity="0.35" />
        <rect x="11.5" y="21" width="9" height="2.6" rx="0.6" fill="#e7ebf1" />
        <rect x="12" y="24" width="8" height="1.8" rx="0.9" fill="#e7ebf1" />
        <rect x="12.6" y="26.2" width="6.8" height="1.8" rx="0.9" fill="#e7ebf1" />
        <path d="M18 5.8 L11 15.2 L14.8 15.2 L13 22.2 L21 11.6 L16.6 11.6 Z" fill="#0a1a2e" opacity="0.18" transform="translate(0.4,0.4)" />
        <path d="M18 5.8 L11 15.2 L14.8 15.2 L13 22.2 L21 11.6 L16.6 11.6 Z" fill="#0072bc" />
        <circle cx="13" cy="22.2" r="1.3" fill="#0072bc" />
      </svg>
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-display font-bold text-[15px]" style={{ color: wordmarkColor }}>
            CurrentControl
          </div>
          <div className="text-[9.5px] tracking-[.14em] uppercase" style={{ color: subColor }}>
            franchise ops platform
          </div>
        </div>
      )}
    </div>
  );
}
